import { Transition } from "@headlessui/react";
import { MdSearch } from "react-icons/md";

import { SearchFlyout } from "../SearchFlyout";

import type { JSX } from "react";

interface Props {
  isOpen: boolean;
  searchTerm: string;
  onSearchTermChange: (term: string) => void;
  onSearch: () => void;
  onClose: () => void;
}

/** Busca mobile em tela cheia: campo + "Cancelar" e buscas populares. Controlada por `activeFlyout === "busca"`. */
export const MobileSearch = ({ isOpen, searchTerm, onSearchTermChange, onSearch, onClose }: Props): JSX.Element => (
  <Transition
    show={isOpen}
    as="div"
    className="fixed inset-0 z-40 bg-base-white p-2 transition duration-150 ease-out data-[closed]:opacity-0 lg:hidden"
  >
    <div className="mb-3 flex items-center gap-2">
      <div className="relative flex grow items-center rounded-full bg-base-input-opacity-50">
        <MdSearch size="1.25rem" className="pointer-events-none absolute left-2" />

        <input
          autoFocus
          value={searchTerm}
          onChange={(event) => onSearchTermChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              onSearch();
            }
          }}
          placeholder="Busque estampas ou produtos"
          aria-label="Buscar"
          className="h-5 w-full rounded-full bg-transparent pl-5 pr-2 outline-none"
        />
      </div>

      <button type="button" onClick={onClose} className="text-sm font-bold">
        Cancelar
      </button>
    </div>

    <SearchFlyout />
  </Transition>
);
